<ng-template #face>
  <span class="account-card__top">
    <span class="account-card__brand">
      @if (item.view.brandKey === 'freely') {
        <img class="account-card__brand-image" src="assets/payment-method/freely.png" alt="" />
      } @else {
        <i class="account-card__brand-icon {{ item.view.brandIcon }}" aria-hidden="true"></i>
      }
      <span class="account-card__brand-label">{{ item.view.brandLabel }}</span>
    </span>
    @if (selectable) {
      <mat-icon class="account-card__check" aria-hidden="true">
        {{ selected ? 'check_circle' : 'radio_button_unchecked' }}
      </mat-icon>
    }
  </span>

  <span class="account-card__number">•••• {{ item.view.last4 || '····' }}</span>
  <span class="account-card__holder">{{ item.view.holderName || 'No name on file' }}</span>

  <span class="account-card__meta">
    @if (item.view.rail === 'CARD') {
      @if (item.view.expiry) {
        <span>Exp {{ item.view.expiry }}</span>
      }
      @if (item.view.expired) {
        <span class="account-card__tag account-card__tag--warn">expired</span>
      }
      @if (item.view.fundingLabel) {
        <span class="account-card__tag">{{ item.view.fundingLabel }}</span>
      }
      @if (item.view.notAccepted) {
        <span class="account-card__tag account-card__tag--warn">debit not accepted</span>
      }
    } @else {
      <span>Routing {{ item.view.routing || '—' }}</span>
      <span class="account-card__tag">ACH</span>
    }
  </span>
</ng-template>

<div
  class="account-card account-card--{{ item.view.brandKey }}"
  [class.account-card--selected]="selectable && selected"
  [class.account-card--expired]="item.view.expired || item.view.notAccepted"
  [class.account-card--static]="!selectable"
>
  @if (selectable) {
    <button
      type="button"
      class="account-card__body"
      role="radio"
      [attr.aria-checked]="selected"
      [disabled]="item.view.notAccepted"
      [attr.aria-label]="item.view.ariaLabel + (item.view.notAccepted ? ', debit cards not accepted' : '')"
      (click)="choose.emit(item.method)"
    >
      <ng-container *ngTemplateOutlet="face" />
    </button>
  } @else {
    <div class="account-card__body" [attr.aria-label]="item.view.ariaLabel">
      <ng-container *ngTemplateOutlet="face" />
    </div>
  }

  <div class="account-card__footer">
    @if (item.method.isDefault) {
      <span class="account-card__default">
        <mat-icon aria-hidden="true">star</mat-icon>default
      </span>
    } @else if (!item.view.notAccepted) {
      <button
        type="button"
        mat-button
        color="primary"
        class="account-card__set-default"
        matTooltip="make this the customer's default account — it is preselected when collecting a payment, and AutoPay charges it"
        matTooltipPosition="above"
        (click)="setDefault.emit(item.method)"
      >set as default</button>
    }
    @if (actions.length) {
      <button
        type="button"
        mat-icon-button
        class="account-card__menu"
        [matMenuTriggerFor]="accountMenu"
        [attr.aria-label]="'More actions for ' + item.view.ariaLabel"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #accountMenu="matMenu" xPosition="before">
        @for (a of actions; track a.label) {
          <button type="button" mat-menu-item (click)="action.emit(a)">{{ a.label }}</button>
        }
      </mat-menu>
    }
  </div>
</div>
